import { Props } from './types';
import * as Styled from './styled';

function Footer({
  rightButton,
  leftButton,
  marginTop,
  marginTopSM,
  columnSM,
  havePaddingBottom,
  havePaddingBottomSM,
  marginSide,
  withDivider,
  children,
}: Props) {
  return (
    <Styled.Footer
      data-testid="footer"
      $marginTop={marginTop}
      $marginTopSM={marginTopSM}
      $haveLeftButton={!!leftButton}
      $haveChildren={!!children}
      $isColumn={columnSM}
      $havePaddingBottom={havePaddingBottom}
      $havePaddingBottomSM={havePaddingBottomSM}
      $marginSide={marginSide}
      $withDivider={withDivider}
    >
      {children}
      <Styled.ContainerButton $isColumn={columnSM}>
        {leftButton}
        {!!leftButton && <Styled.Gap $isColumn={columnSM} data-testid="gap" />}
        {rightButton}
      </Styled.ContainerButton>
    </Styled.Footer>
  );
}

Footer.defaultProps = {
  havePaddingBottom: false,
  havePaddingBottomSM: false,
  withDivider: true,
};

export default Footer;
